export default __webpack_public_path__ + "Karthik_CV_2024.pdf";